export default __webpack_public_path__ + "static/media/admissionOfficerSign.a7430ddd.png";